
































































































import { Vue, Component } from "vue-property-decorator"
import { getModule } from "vuex-module-decorators"
import { Server, InvitationInfo } from "@/store/server"

@Component
export default class InviteAcceptView extends Vue {
  info: InvitationInfo | null = null
  loadingInfo = true
  loadError = false
  submitting = false

  form = {
    password: '',
    name: '',
    // eslint-disable-next-line
    name_furigana: '',
    // eslint-disable-next-line
    phone_number: '',
  }
  passwordConfirm = ''

  async mounted() {
    const token = this.$route.params.token
    try {
      this.info = await getModule(Server).getInvitationInfo(token)
    } catch (error) {
      this.loadError = true
    } finally {
      this.loadingInfo = false
    }
  }

  get furiganaError() {
    if (this.form.name_furigana.length === 0) return ''
    return /^[ぁ-んー]+$/.test(this.form.name_furigana) ? '' : 'ひらがなで入力してください。'
  }

  get phoneError() {
    if (this.form.phone_number.length === 0) return ''
    return /^\d{10,11}$/.test(this.form.phone_number) ? '' : '10～11桁の数字で入力してください。'
  }

  get passwordConfirmError() {
    if (this.passwordConfirm.length === 0) return ''
    return this.passwordConfirm === this.form.password ? '' : 'パスワードと一致しません。'
  }

  get canSubmit() {
    return this.form.name.length > 0 &&
      this.form.name_furigana.length > 0 && this.furiganaError === '' &&
      this.form.phone_number.length > 0 && this.phoneError === '' &&
      this.form.password.length >= 8 &&
      this.passwordConfirm === this.form.password &&
      !this.submitting
  }

  async submit() {
    const token = this.$route.params.token
    this.submitting = true
    try {
      await getModule(Server).postInvitationAccept({ token, payload: this.form })
      this.$buefy.toast.open({ message: 'アカウントを作成しました。', type: 'is-success' })
      this.$router.replace('/')
    } catch (error) {
      this.$buefy.toast.open({ message: 'アカウント作成に失敗しました。', type: 'is-danger' })
    } finally {
      this.submitting = false
    }
  }

  roleLabel(role: string) {
    if (role === 'member') return '管理者 (member)'
    if (role === 'viewer') return '閲覧専用'
    return role
  }

  formatTimestamp(ts: number) {
    return new Date(ts * 1000).toLocaleString('ja-JP')
  }
}
